<div class="calendar-container" (click)="$event.stopPropagation()">
  <div class="date-header">{{headerName}}</div>

  <div class="calendar-card">
    <div class="calendar-wrapper">
      <div  *ngIf="Weekstyle=='month'" style="width: 233px;border: 1px solid #E8EAEE;background: #00000014;position: absolute;top: 106px;left: 10px;height: 30px;border-radius: 20px;"></div>
      <mat-calendar
        #calendar
        style="margin-top: -16px;"
        [selected]="selectedEndDate"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [dateClass]="dateClass"
        [dateFilter]="DateFilter"
        [startAt]="startAt"
        [startView]="'month'"
        (selectedChange)="selectDate($event)"
        (viewChanged)="onViewChanged('start', $event)"
      ></mat-calendar>
    </div>
  </div>
  

  <div class="date-inputs">
    <div class="input-group">
      <span class="input-group-text" style="padding: 9px 8.5px !important;" >Start Date</span>
      <input type="text" style="height: 38px;width: 20px;font-size: 12px;" class="form-control" placeholder=" " [value]="selectedStartDate | date: 'MM.dd.yyyy'" readonly />
    </div>
    <div class="input-group">
      <span class="input-group-text">End Date</span>
      <input type="text" style="height: 38px;width: 20px;font-size: 12px;" class="form-control" placeholder=" " [value]="selectedEndDate | date: 'MM.dd.yyyy'" readonly />
    </div>
  </div>

  <div class="actions">
    <button matTooltip="Clear Selection" class="btn clear" (click)="clearDates()">
      Clear
    </button>
    <button matTooltip="Apply Selection" style="box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);" class="btn apply"  cdkMenu [disabled]="!selectedStartDate || !selectedEndDate" (click)="applyDates()">
      Apply
    </button>
  </div>
</div>